import {
  Table,
  TableBody,
  Grid,
  TextField,
  TableCell,
  TableRow
} from '@material-ui/core';
import React, { Component } from 'react';
import store from '../../store/appStore';
import PageHeader from '../common/PageHeader';
import { apiBatchRequest, downloadReport } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';
import {
  GenerateAbsoluteURL,
  getCurrentPayCycleEndDateByDate,
  getCurrentPayCycleStartDateByDate,
  removeDuplicates,
  disableDatesForPayCycleStart1,
  disableDatesForPayCycleEnd1,
  getNumberOfPayCycle,
  IsSensitiveDataAccess,
  EnhancedTableHead,
  orderBy
  , numberWithCommas,
  getPreviousPayCycle,
  with2DecimalsPoints,
  IsAutoRunPagesEnabled,
  getMaxDate
} from '../../utils/helper';
import _, { cloneDeep } from 'lodash';
import Reports from './Reports';
import { Switch } from '../common/Switch';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import { DateFormat, DOWNLOAD_DATA_MESSAGE } from '../../constants/appConstants';
import ReportButtons from './ReportButtons';
import AdvancedFilter from './AdvancedFilter';
import './report.less';
import { getFormattedValues } from '../../utils/formatData';
import { getMultilevelGroupedData } from '../../utils/generic';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ConfirmDialog from '../common/Dailogbox/confirmDailog';
import TableWithPaginations from './TableWithPaginations';
import { collapsableAllocationPercent, collapsableReimbursement, extendibleMarkerReimbursArray } from '../../constants/MockData';
import PageLandingMessage from '../common/PageLandingMessage/PageLandingMessage';

let defaultPayPeriod = [];

export default class MarketReimbursementReport extends Component {
  // Constructor to intitialize state
  constructor(props) {
    super(props);
    const { user } = store.getState();
    this.baseState = {
      showMain: false,
      departmentMasterData: [],
      employeeMasterData: [],
      marketMasterData: [],
      expenseGroupMasterData: [],
      divisionMasterData: [],
      expenseNameMasterData: [],
      detailView: false,
      selectedEmployeeId: undefined,
      openForm: false,
      payPeriodStartDate: getPreviousPayCycle().previousPayCycleStartDate,
      payPeriodEndDate: getPreviousPayCycle().previousPayCycleEndDate,
      futureEndDate: getCurrentPayCycleEndDateByDate(moment().format(DateFormat)),
      maxEndDate: getPreviousPayCycle().previousPayCycleEndDate,
      pastStartDate: getCurrentPayCycleEndDateByDate(moment().format(DateFormat)).subtract(3, 'M').format('MM/DD/YYYY'),
      selectedData: [],
      marketReimburseData: [],
      rows: [],
      payPeriodRadio: '',
      showReport: false,
      market: [{ marketName: 'All' }],
      department: [{ departmentName: 'All' }],
      property: [{ propertyName: 'All' }],
      employee: [{ employeeName: 'All' }],
      expenseGroup: [{ expenseGroup: 'All' }],
      expenseName: [{ expenseName: 'All' }],
      division: [{ division: 'All' }],
      SupervisorEmployee: [{ employeeName: 'All' }],
      openSlidingPanel: false,
      advanceFilterConfig: {
        groupBy: {
          masterData: [
            {
              key: 'Department',
              id: 'departmentName',
              value: 'departmentName',
              ssrsReport: 'DepartmentName',
              numeric: false,
              disablePadding: false,
              label: 'Department',
              type: 'Text',
              order: 2
            },
            {
              key: 'Division',
              id: 'division',
              value: 'division',
              ssrsReport: 'Division',
              numeric: false,
              disablePadding: false,
              label: 'Division',
              type: 'Text',
              order: 3
            },
            {
              key: 'Employee',
              value: 'employeeName',
              id: 'employeeName',
              ssrsReport: 'Employee',
              numeric: false,
              disablePadding: false,
              label: 'Employee',
              type: 'Text',
              order: 4
            },
            {
              key: 'Expense Group',
              value: 'expenseGroup',
              id: 'expenseGroup',
              ssrsReport: 'ExpenseGroup',
              numeric: false,
              disablePadding: false,
              label: 'Expense Group',
              type: 'Text',
              order: 5
            },
            {
              key: 'Expense Name',
              value: 'expenseName',
              id: 'expenseName',
              ssrsReport: 'ExpenseName',
              numeric: false,
              disablePadding: false,
              label: 'Expense Name',
              type: 'Text',
              order: 6
            }],
          selected: [{
            key: 'Market',
            value: 'marketName',
            id: 'marketName',
            ssrsReport: 'MarketName',
            numeric: false,
            disablePadding: false,
            label: 'Market',
            type: 'Text',
            order: 1
          }]
        },
        selectedDate: {},
        suppressGraph: false,
        suppressZero: true,
        summaryRows: true,
        suppressDetails: false,
        showZeroNGraph: true,
        startDate: getPreviousPayCycle().previousPayCycleStartDate,
        endDate: getPreviousPayCycle().previousPayCycleEndDate,
        RadioSelect: 'MTD'
      },
      summaryCols: ['reimbursementCost'],
      printPage: false,
      payPeriod: [],
      expand: false,
      openDialog: false,
      dialogTitle: null,
      agree: false,
      confirmationMessage: '',
      handleCollapse: false,
      order: 'asc',
      orderBy: 'nam',
      supervisorEmployeeMasterData: [],
      showSingleTotal: false,
      isAutoRunEnabled: IsAutoRunPagesEnabled(),
      isSubmitButtonClicked: false,
      downloadMessage: null,
      isUnlimitedPayCyclesEnabled: (user.userData || {})?.isUnlimitedPayPeriodsEnabledForReports || false,
      noOfAllowedPayPeriodsForReports: (user.userData || {})?.noOfAllowedPayPeriodsForReports || 12,
      noOfAllowedPayPeriodsForReportsUI: (user.userData || {})?.NoOfAllowedPayPeriodsForReportsUI || 4,
      noOfMarketsInSingleRequestForReimbursement: (user.userData || {})?.noOfMarketsInSingleRequestForReimbursement || 0
    };

    this.state = this.baseState;
  }

  // This method is used to get master data
  componentDidMount() {
    localStorage.setItem('selectedstartDate', moment().startOf('month').format('MM/DD/YYYY'));
    localStorage.setItem('selectedendDate', moment().endOf('month').format('MM/DD/YYYY'));
    this.GetMasterData();
  }

  // Get Master Data by calling APIs to fill filter's data
  GetMasterData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetEmployeeMasterData + '?showInActive=true',
        key: 'employeeMasterData'
      },
      {
        url: API_URL.Employee.GetDepartmentMasterData,
        key: 'departmentMasterData',
        fromCache: true,
        duration: 15
      },
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: 'marketMasterData',
        fromCache: true,
        duration: 15
      },
      {
        url: API_URL.Report.GetExpenseGroup,
        key: 'expenseGroupMasterData'
      },
      {
        url: API_URL.Report.GetExpenseName,
        key: 'expenseNameMasterData'
      },
      {
        url: API_URL.Allocation.GetDivisions,
        key: 'divisionMasterData'
      }
    ])
      .then(
        ({
          employeeMasterData,
          departmentMasterData,
          marketMasterData,
          expenseGroupMasterData,
          expenseNameMasterData,
          divisionMasterData
        }) => {
          this._asyncRequest = null;
          if (marketMasterData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }
          this.setState({
            employeeMasterData: employeeMasterData.data,
            departmentMasterData: departmentMasterData.data,
            marketMasterData: marketMasterData.data,
            expenseGroupMasterData: expenseGroupMasterData.data,
            expenseNameMasterData: expenseNameMasterData.data,
            divisionMasterData: divisionMasterData.data,
            supervisorEmployeeMasterData: employeeMasterData.data || []
          }, () => {
            if(this.state.isAutoRunEnabled || this.state.isSubmitButtonClicked) {
              this.handleSubmit();
            }
          });
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  // Check selected pay cycle counts validations, Don't allow to get data for more than 3 pay periods
  handlePayCycles() {
    const { fromDate, toDate } = this.getPayCyclesFromState();
    const count = getNumberOfPayCycle(fromDate, toDate);
    if (count > 3) {
      this.setState({
        openDialog: true
      });
    } else {
      this.GetMarketReimburseData();
    }
  }

  // Confirmation box option selection event
  // Download report if selected value is true
  onConfirmClickHandle = (value) => {
    if (value) {
      this.setState({
        openDialog: false,
        marketReimburseData: [],
        rows: [],
        showReport: true,
        downloadMessage: DOWNLOAD_DATA_MESSAGE,
        isSubmitButtonClicked: true
      }, () => {this.downloadFile(this.state.fileMimeType, this.state.type, this.state.isPrint)});
    } else {
      this.setState({
        openDialog: false
      });
    }
  }

  // Get From and To Date from the state to fetch the report data
  getPayCyclesFromState() {
    const {
      payPeriodStartDate, payPeriodEndDate
    } = this.state;
    const fromDate = payPeriodStartDate == null
      ? getCurrentPayCycleStartDateByDate(moment())
      : payPeriodStartDate;
    const toDate = payPeriodEndDate == null
      ? getCurrentPayCycleEndDateByDate(moment())
      : payPeriodEndDate;
    return { fromDate, toDate };
  }

  // Get Market Reimbursement Report based on selected filters
  GetMarketReimburseData() {
    const {
      market,
      property,
      department,
      employee,
      payPeriodStartDate,
      payPeriodEndDate,
      expenseGroup,
      expenseName,
      division,
      SupervisorEmployee,
      showSingleTotal
    } = this.state;

    const marketId = _.cloneDeep(market.map((x) => x.marketId));
    const propertyId = _.cloneDeep(property.map((x) => x.propertyId));
    const departmentId = _.cloneDeep(department.map((x) => x.departmentId));
    const employeeId = _.cloneDeep(employee.map((x) => x.employeeId));
    const expenseGroupId = _.cloneDeep(expenseGroup.map((x) => x.expenseGroupId));
    const expenseNameId = _.cloneDeep(expenseName.map((x) => x.expenseNameId));
    const divisionId = _.cloneDeep(division.map(x => x.divisionId));
    const supervisorId = _.cloneDeep(SupervisorEmployee.map((x) => x.ultiProEmployeeId));

    const fromDate =
      payPeriodStartDate == null
        ? getCurrentPayCycleStartDateByDate(moment())
        : payPeriodStartDate;
    const toDate =
      payPeriodEndDate == null
        ? getCurrentPayCycleEndDateByDate(moment())
        : payPeriodEndDate;

    this.validateDate(fromDate, toDate, marketId, propertyId, departmentId, employeeId, expenseGroupId, expenseNameId, divisionId, supervisorId, showSingleTotal);
  }

  // Click event of Back button, It will navigate to Reports list view
  goBack = () => {
    this.setState({
      showMain: true
    });
  };

  // Advanced filter change event
  // Used to group the data as per groups selection in Advanced filter
  onAddvanceFilterChange = (advanceFilterConfig) => {
    localStorage.setItem('selectedstartDate', this.state.payPeriodStartDate);
    localStorage.setItem('selectedendDate', this.state.payPeriodEndDate);
    this.setState({
      advanceFilterConfig: advanceFilterConfig,
      openSlidingPanel: false,
      orderBy: advanceFilterConfig?.groupBy?.selected.length > 0
        ? advanceFilterConfig?.groupBy?.selected[0]?.value
        : (advanceFilterConfig?.groupBy?.masterData[0]?.value !== undefined ? advanceFilterConfig?.groupBy?.masterData[0]?.value : this.state.orderBy),
      order: advanceFilterConfig?.groupBy?.selected.length > 0
        ? 'asc'
        : (advanceFilterConfig?.groupBy?.masterData[0]?.value !== undefined ? 'asc' : this.state.order)
    }, () => this.GetMarketReimburseData());
  }

  // Event when filter value selection is changed
  handleChange = (e, value, name, optionLabel) => {
    if (name !== null) {
      if ((this.state[name] || []).find(x => x[optionLabel] === 'All') === undefined) {
        if (value && value.length === 0) {
          value = [{ [optionLabel]: 'All' }];
          this.setState({ [name]: value });
        } else if ((value || []).find(x => x[optionLabel] === 'All')) {
          this.setState({ [name]: [{ [optionLabel]: 'All' }] });
        } else {
          this.setState({ [name]: value });
        }
      } else {
        value = (value || []).filter(x => x[optionLabel] !== 'All');
        if (value && value.length === 0) {
          value = [{ [optionLabel]: 'All' }];
        }
        this.setState({ [name]: value });
      }
    } else {
      this.setState({ [name]: e.target.value });
    }
  };

  // Close the Panel
  handleClose = () => {
    this.setState({
      openSlidingPanel: false
    });
  };

  // Close the dialog box
  handleDialogClose = () => {
    this.setState({
      openDialog: false
    });
  }

  // Open dialog box
  handleClickOpenDialog = () => {
    this.setState({
      openDialog: true
    });
  }

  // Date change event of calendar
  handleDateChange = (date, name) => {
    let { advanceFilterConfig, payPeriodEndDate, noOfAllowedPayPeriodsForReports } = this.state;
    localStorage.setItem('DateRadioSelect', 'CDR');
    let formattedDate = moment(date).format(DateFormat);
    if (formattedDate !== 'Invalid date') {
      const count = getNumberOfPayCycle(formattedDate, payPeriodEndDate);
      let futureEndDate = getMaxDate(formattedDate);
      if (count > 2) {
        payPeriodEndDate = futureEndDate;
      }
      if (name === 'payPeriodStartDate') {
        formattedDate = getCurrentPayCycleStartDateByDate(date).format(DateFormat);

        advanceFilterConfig.startDate = formattedDate;
        localStorage.setItem('selectedstartDate', formattedDate);
        const futureEndDate = moment(getCurrentPayCycleEndDateByDate(moment(formattedDate).add((noOfAllowedPayPeriodsForReports/2), 'M').subtract(1, 'days').format('MM/DD/YYYY'))).format('MM/DD/YYYY');
        this.setState({
          [name]: formattedDate, 
          futureEndDate: (this.state.isUnlimitedPayCyclesEnabled === true ? undefined : futureEndDate),
          payPeriodEndDate: payPeriodEndDate // futureEndDate
        });     
      } else {
        formattedDate = getCurrentPayCycleEndDateByDate(date).format(DateFormat);

        advanceFilterConfig.endDate = formattedDate;
        localStorage.setItem('selectedendDate', formattedDate);
        this.setState({
          [name]: formattedDate
        });
      }
    }
  };

  // Disable other dates  except pay cycle start dates (i.e. Excluding 1 & 16) on Pay Cycle Start calendar 
  disableDatesForPayCycleStart = (date) => {
    return disableDatesForPayCycleStart1(date);
  }

  // Disable other date except pay cycle end dates (i.e. excluding mid and last day of the month) on Pay Cycle End calendar
  disableDatesForPayCycleEnd = (date) => {
    return disableDatesForPayCycleEnd1(date);
  }

  // Expand pay period details. Show pay period wise other columns along with Amount columns
  expandAll = (e) => {
    const collapsePayPeriod = (this.state.payPeriod || []);
    (collapsePayPeriod.filter(d => d.isCollapsed === e.target.checked) || []).forEach((x) => {
      x.isCollapsed = !e.target.checked;
    });
    defaultPayPeriod = collapsePayPeriod;
    const rows = this.getTableRow(this.state.marketReimburseData || []);
    this.setState({
      expand: e.target.checked,
      payPeriod: collapsePayPeriod,
      rows
    }, () => { this.forceUpdate(); });
  }

  // Reset all filter values
  resetPage = () => {
    const { advanceFilterConfig } = this.state;
    advanceFilterConfig.summaryRows = true;
    advanceFilterConfig.suppressZero = true;
    advanceFilterConfig.suppressDetails = false;

    advanceFilterConfig.groupBy = {
      masterData: [
        {
          key: 'Department',
          id: 'departmentName',
          value: 'departmentName',
          ssrsReport: 'DepartmentName',
          numeric: false,
          disablePadding: false,
          label: 'Employee',
          type: 'Text',
          order: 2
        },
        {
          key: 'Division',
          id: 'division',
          value: 'division',
          ssrsReport: 'Division',
          numeric: false,
          disablePadding: false,
          label: 'Division',
          type: 'Text',
          order: 3
        },
        {
          key: 'Employee',
          value: 'employeeName',
          id: 'employeeName',
          ssrsReport: 'Employee',
          numeric: false,
          disablePadding: false,
          label: 'Employee',
          type: 'Text',
          order: 4
        },
        {
          key: 'Expense Group',
          value: 'expenseGroup',
          id: 'expenseGroup',
          ssrsReport: 'ExpenseGroup',
          numeric: false,
          disablePadding: false,
          label: 'Expense Group',
          type: 'Text',
          order: 5
        },
        {
          key: 'Expense Name',
          value: 'expenseName',
          id: 'expenseName',
          ssrsReport: 'ExpenseName',
          numeric: false,
          disablePadding: false,
          label: 'Expense Name',
          type: 'Text',
          order: 6
        }],
      selected: [{
        key: 'Market',
        value: 'marketName',
        id: 'marketName',
        ssrsReport: 'MarketName',
        numeric: false,
        disablePadding: false,
        label: 'Market',
        type: 'Text',
        order: 1
      }]
    };
    this.setState({
      ...this.baseState,
      isSubmitButtonClicked: false,
      downloadMessage: null,
      advanceFilterConfig
    });
    this.componentDidMount();
  };

  // Submit button click event
  // Used to get data from API based on selected filters
  handleSubmit = () => {
    localStorage.setItem('DateRadioSelect', 'CDR');
    localStorage.setItem('selectedstartDate', this.state.payPeriodStartDate);
    localStorage.setItem('selectedendDate', this.state.payPeriodEndDate);
    const { fromDate, toDate } = this.getPayCyclesFromState();
    const count = getNumberOfPayCycle(fromDate, toDate);
    if (this.state.isUnlimitedPayCyclesEnabled !== true && count > this.state.noOfAllowedPayPeriodsForReports) {
      const message = 'You can select maximum ' + this.state.noOfAllowedPayPeriodsForReports + ' paycycles';
      ShowToast(
        message,
        toastType.WARNING,
        5000,
        500
      );
    } else {
      this.GetMarketReimburseData();
    }    
  };

  // Open Panel
  handleClickOpen = () => {
    localStorage.setItem('selectedstartDate', this.state.payPeriodStartDate);
    localStorage.setItem('selectedendDate', this.state.payPeriodEndDate);
    this.setState({
      openSlidingPanel: true
    });
  };

  // Print report button click event. It will open the report into another tab of browser in pdf format for print
  handlePrintClick = () => {
    this.handleExport('application/pdf', 'Pdf', true);
  };

  getSupprssDetailsColumnCount = () => {
    if (this.state.advanceFilterConfig.suppressDetails) {
      const columns = [];
      const allColumns = removeDuplicates([...this.state.advanceFilterConfig.groupBy.selected, ...this.state.advanceFilterConfig.groupBy.masterData], 'key');
      const selectedColumns = removeDuplicates([...this.state.advanceFilterConfig.groupBy.selected], 'key');
      const diffColumns = allColumns.length - selectedColumns.length;
      for (let c = 0; c < diffColumns; c++) {
        columns.push(c + 1);
      }
      return columns;
    } else {
      return [];
    }
  }

  // Get columns with sequence to display the data based on grouping selected from advanced filter
  getColumnSequence = () => {
    if (this.state.advanceFilterConfig.suppressDetails) {
      return removeDuplicates([...this.state.advanceFilterConfig.groupBy.selected], 'key');
    } else {
      return removeDuplicates([...this.state.advanceFilterConfig.groupBy.selected, ...this.state.advanceFilterConfig.groupBy.masterData], 'key');
    }
  }

  // Adjust column sequene when selected/deselected from grouping in Advance filter
  adjustColumnSequence = (currentGroupedRow) => {
    this.state.advanceFilterConfig.groupBy.masterData.forEach(x => {
      currentGroupedRow.push({ key: x.value });
    }
    );
    return currentGroupedRow;
  }

  // Render table cell with formatted data
  renderTableCell = (groupedData, currentGroupedRow = [], tableCell = [], rowCount = 0) => {    
    const payPeriod = defaultPayPeriod;

    const showSummary = this.state.advanceFilterConfig.summaryRows;
    const suppressDetails = this.state.advanceFilterConfig.suppressDetails;
    const sequence = this.getColumnSequence();
    let column1 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[0]?.value) || {}).value ?? '' : '';
    let column2 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[1]?.value) || {}).value ?? '' : '';
    let column3 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[2]?.value) || {}).value ?? '' : '';
    let column4 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[3]?.value) || {}).value ?? '' : '';
    let column5 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[4]?.value) || {}).value ?? '' : '';
    let column6 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[5]?.value) || {}).value ?? '' : '';

    groupedData.forEach((d, i) => {
      if (d.data !== undefined) {
        rowCount = 0;
        currentGroupedRow = currentGroupedRow.filter(x => x.key !== d.key);
        currentGroupedRow.push({ key: d.key, value: d[d.key] });
        if (this.state.advanceFilterConfig.summaryRows === false) {
          this.renderTableCell(d.data, currentGroupedRow, tableCell, rowCount);
        }
      }
      const keyvalue = this.adjustColumnSequence(_.cloneDeep(currentGroupedRow));
      const sequence = this.getColumnSequence();

      if (d.reimbursmentDetails) {
        const evenOddClass =
          tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
        const topBorderClass =
          column1 !== (keyvalue.find(x => x.key === sequence[0]?.value) || {}).value ?? '' ? ' rpt-topBorder ' : ' ';        
        const key = d.marketName + '_' + d.departmentName + d.division + '_' + d.employeeName + '_' + rowCount + '_' + i + d.isGroup;
        if (d.reimbursmentDetails.length > 0 &&
          (d.reimbursmentDetails[0].isSummary === undefined ||
            (d.reimbursmentDetails.length > 0 && d.reimbursmentDetails[0].isSummary === true &&
              this.state.advanceFilterConfig.summaryRows === true))) {
          if ((suppressDetails && d.isGroup) || (!suppressDetails)) {
            tableCell.push(
              <TableRow                
                className={(this.state.advanceFilterConfig.summaryRows === true ? topBorderClass : '') + (d.isGroup === true ? ' parent-row' : '')}
              >
                {((d[sequence[0]?.value] || (!suppressDetails)) || (suppressDetails && sequence[0]?.value !== '')) && (
                  <TableCell
                    className={'st sticky ' + evenOddClass + (column1 !== d[sequence[0]?.value] &&
                      ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[0]?.value])
                      ? topBorderClass
                      : '')}
                  >
                    {getFormattedValues(column1 !== d[sequence[0]?.value] && d[sequence[0]?.value], 'Text')}{' '}
                  </TableCell>
                )
                }
                {((d[sequence[1]?.value] || (!suppressDetails)) || (suppressDetails && sequence[1]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-1 ' +
                      evenOddClass +
                      (column2 !== d[sequence[1]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[1]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >                    
                    {d.isGroup === true && getFormattedValues(column2 !== d[sequence[1]?.value] && d[sequence[1]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[1]?.value)}</span>
                      : getFormattedValues(column2 !== d[sequence[1]?.value] && d[sequence[1]?.value], 'Text')}
                  </TableCell>
                )
                }
                {((d[sequence[2]?.value] || (!suppressDetails)) || (suppressDetails && sequence[2]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-2 ' +
                      evenOddClass +
                      (column3 !== d[sequence[2]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[2]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >                    
                    {d.isGroup === true && getFormattedValues(column3 !== d[sequence[2]?.value] && d[sequence[2]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[2]?.value)}</span>
                      : getFormattedValues(column3 !== d[sequence[2]?.value] && d[sequence[2]?.value], 'Text')}
                  </TableCell>
                )
                }
                {((d[sequence[3]?.value] || (!suppressDetails)) || (suppressDetails && sequence[3]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-3 ' +
                      evenOddClass +
                      (column4 !== d[sequence[3]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[3]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >                    
                    {d.isGroup === true && getFormattedValues(column4 !== d[sequence[3]?.value] && d[sequence[3]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[3]?.value)}</span>
                      : getFormattedValues(column4 !== d[sequence[3]?.value] && d[sequence[3]?.value], 'Text')}
                  </TableCell>
                )
                }
                {((d[sequence[4]?.value] || (!suppressDetails)) || (suppressDetails && sequence[4]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-4 ' +
                      evenOddClass +
                      (column5 !== d[sequence[4]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[4]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >                    
                    {d.isGroup === true && getFormattedValues(column5 !== d[sequence[4]?.value] && d[sequence[4]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[4]?.value)}</span>
                      : getFormattedValues(column5 !== d[sequence[4]?.value] && d[sequence[4]?.value], 'Text')}
                  </TableCell>
                )
                }
                {((d[sequence[5]?.value] || (!suppressDetails)) || (suppressDetails && sequence[5]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-5 ' +
                      evenOddClass +
                      (column6 !== d[sequence[5]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[5]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >                    
                    {d.isGroup === true && getFormattedValues(column6 !== d[sequence[5]?.value] && d[sequence[5]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[5]?.value)}</span>
                      : getFormattedValues(column6 !== d[sequence[5]?.value] && d[sequence[5]?.value], 'Text')}
                  </TableCell>
                )
                }
                {payPeriod.map((date, ind) => (
                  this.renderReimbursementColumn(d.reimbursmentDetails, date, key + ind, evenOddClass, d)
                ))}
              </TableRow>
            );
          }
        }
        rowCount++;
        column1 = (keyvalue.find(x => x.key === sequence[0]?.value) || {}).value ?? '';
        column2 = (keyvalue.find(x => x.key === sequence[1]?.value) || {}).value ?? '';
        column3 = (keyvalue.find(x => x.key === sequence[2]?.value) || {}).value ?? '';
        column4 = (keyvalue.find(x => x.key === sequence[3]?.value) || {}).value ?? '';
        column5 = (keyvalue.find(x => x.key === sequence[4]?.value) || {}).value ?? '';
        column6 = (keyvalue.find(x => x.key === sequence[5]?.value) || {}).value ?? '';
      }
      if (d.data !== undefined && this.state.advanceFilterConfig.summaryRows === true && d.isGroup === true) {
        this.renderTableCell(d.data, currentGroupedRow, tableCell, rowCount);
      }
    });
    return tableCell;
  }

  getGroupedArray(d, key) {
    // return [...new Set(d.data.map(x => x[key]))].length;
    return '';
  }

  // Render Reimbursement columns for the pay periods
  renderReimbursementColumn = (reimbursementDetails, payPeriod, index, evenOddClass, d) => {
    const reimbursementDetail = reimbursementDetails.filter(x => moment(x.payPeriod).format(DateFormat) === moment(payPeriod.payPeriod).format(DateFormat));
    const isSensitiveData = IsSensitiveDataAccess();

    const tableCell = [];
    tableCell.push(<>
      {(payPeriod.isCollapsed === false || !isSensitiveData) && (
        <>
          <TableCell className={(evenOddClass + 'rpt-topBorder')} key={index + 'allocationRate'}>
            {
              reimbursementDetail.map((reimburse, ind) =>
                <div key={index + 'allocationRate' + ind} className={((reimbursementDetail.length) > 1 &&
                  ind !== (reimbursementDetail.length - 1))
                  ? 'multi-pay-period'
                  : ''}>
                  {d.isGroup === true && reimburse.allocationRate === undefined
                    ? <span className='total-count'>{this.getGroupedArray(reimburse, reimburse.allocationRate)}</span>
                    : (reimburse.allocationRate === null || isNaN(parseFloat(reimburse.allocationRate)))
                      ? <span className="number-text"></span>
                      : (parseFloat(reimburse.allocationRate) >= 0
                        ? <span className={this.state.expand === true ? 'report-percent-allocation-rate-expanded' : 'report-percent-text-rate'}>{numberWithCommas(with2DecimalsPoints(parseFloat(reimburse.allocationRate), 'Percent'))}%</span>
                        : <span className={this.state.expand === true ? 'report-percent-allocation-rate-expanded' : 'report-percent-text-rate'}>({numberWithCommas(with2DecimalsPoints(parseFloat(Math.abs(reimburse.allocationRate)), 'Percent'))})%</span>
                      )
                  }
                </div>
              )
            }
          </TableCell>
        </>)
      }
      {
        (payPeriod.isCollapsed === false && isSensitiveData) && (
          <TableCell className={(evenOddClass + 'rpt-topBorder')} key={index + 'expenseAmount'}>
            {
              reimbursementDetail.map((reimburse, ind) =>
                <div key={index + 'expenseAmount' + ind} className={((reimbursementDetail.length) > 1 &&
                  ind !== (reimbursementDetail.length - 1))
                  ? 'multi-pay-period'
                  : ''}>
                  {(reimburse.expenseAmount === null || isNaN(parseFloat(reimburse.expenseAmount)))
                    ? <span className="number-text">-</span>
                    : (parseFloat(reimburse.expenseAmount) >= 0
                      ? <span className={this.state.expand === true ? 'report-percent-allocation-rate-expanded' : 'report-percent-text-rate'}>${numberWithCommas(with2DecimalsPoints(parseFloat(reimburse.expenseAmount), 'Percent'))}</span>
                      : <span className={this.state.expand === true ? 'report-percent-allocation-rate-expanded' : 'report-percent-text-rate'}>$({numberWithCommas(with2DecimalsPoints(parseFloat(Math.abs(reimburse.expenseAmount)), 'Percent'))})</span>)
                  }
                </div>
              )
            }
          </TableCell>
        )
      }
      {/* If Sensitive Data Access is enabled to the user, then show amount columns */}
      {isSensitiveData
        ? <TableCell className={(evenOddClass + 'right-border  rpt-topBorder')} key={index + 'reimbursementCost'}>
          {
            reimbursementDetail.map((reimburse, ind) =>
              <div key={index + 'reimbursementCost' + ind} className={((reimbursementDetail.length) > 1 &&
                ind !== (reimbursementDetail.length - 1))
                ? 'multi-pay-period'
                : ''}>
                {(reimburse.reimbursementCost === null || isNaN(parseFloat(reimburse.reimbursementCost)))
                  ? <span className="number-text">-</span>
                  : (parseFloat(reimburse.reimbursementCost) >= 0
                    ? <span className={this.state.expand === true ? 'report-percent-text-rate-expanded' : 'report-percent-text-cost'}>${numberWithCommas(with2DecimalsPoints(parseFloat(reimburse.reimbursementCost), 'Percent'))}</span>
                    : <span className={this.state.expand === true ? 'report-percent-text-rate-expanded' : 'report-percent-text-cost'}>$({numberWithCommas(with2DecimalsPoints(parseFloat(Math.abs(reimburse.reimbursementCost)), 'Percent'))})</span>
                  )
                }
              </div>
            )
          }
        </TableCell>
        : ''}
    </>);
    return tableCell;
  }

  // Render Row wise data of table. It will render data cell wise.
  renderTableRow = (data) => {
    if (this.state.advanceFilterConfig.suppressZero === true) {
      data = data.filter(x => {
        return _.chain(x.reimbursmentDetails).sumBy(x => x.reimbursementCost).value() !== 0;
      });
    }
    return this.renderTableCell(
      getMultilevelGroupedData(data, this.state.advanceFilterConfig.groupBy.selected.map((x) => x.value), true, 'Market'),
      []);
  };

  // Get Table Row data with formatted values
  getTableRow = (marketReimburseData) => {    
    let returnRows = [];

    returnRows = [...returnRows, ...this.renderTableRow(
      orderBy(marketReimburseData, this.state.orderBy, this.state.order)
    )];
    return returnRows;
  }

  // Handle sorting of columns
  handleRequestSort = (event, property) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc';
    let rows = [];
    rows = [...rows, ...this.renderTableRow(
      orderBy((this.state.marketReimburseData || []), property, isAsc ? 'desc' : 'asc')
    )];
    this.setState({
      order: isAsc ? 'desc' : 'asc',
      orderBy: property,
      rows
    }, () => { this.forceUpdate(); });
  };

  // Click event of pay period wise arrow to Expand/Collapse the reimbursement columns
  onClickOnArrow = (payPeriod, isCollapsed) => {
    const collapsePayPeriod = (this.state.payPeriod || []);
    collapsePayPeriod.find(d => d.payPeriod === payPeriod).isCollapsed = !isCollapsed;
    defaultPayPeriod = collapsePayPeriod;
    const rows = this.getTableRow(this.state.marketReimburseData || []);
    this.setState({
      payPeriod: collapsePayPeriod,
      handleCollapse: !this.state.handleCollapse,
      rows
    }, () => { this.forceUpdate(); });
  }

  // Render report table
  renderTable = (rows) => {
    const groupSequence = this.getColumnSequence();
    const suppressColumns = this.getSupprssDetailsColumnCount();
    const isSensitiveData = IsSensitiveDataAccess();
    const { payPeriod, showSingleTotal, payPeriodStartDate, payPeriodEndDate } = this.state;
    const collapsableObj = isSensitiveData ? collapsableReimbursement : collapsableAllocationPercent;
    const extendibleArray = isSensitiveData ? extendibleMarkerReimbursArray : [collapsableAllocationPercent];
    const formattedPayPeriod = showSingleTotal === true ? (moment(payPeriodStartDate).format('MM-DD-YYYY') + ' to '+ moment(payPeriodEndDate).format('MM-DD-YYYY')) : null;
    return (
      <Table className="reportTable" id="rptTable">
        <EnhancedTableHead
          order={this.state.order}
          orderBy={this.state.orderBy}
          onRequestSort={this.handleRequestSort}
          rowCount={rows.length}
          columnSequence={groupSequence}
          headCells={[]}
          payPeriod={payPeriod}
          formattedPayPeriod={formattedPayPeriod}
          isMarket={true}
          isSensitiveData={isSensitiveData}
          dynamicColumnCount={[1, 2, 3, 4, 5]}
          suppressDetailsColumnCount={suppressColumns}
          extendibleArray={extendibleArray}
          collapsableObj={collapsableObj}
          onClickOnArrow={this.onClickOnArrow}
          expand={this.state.expand}
          expandAll={this.expandAll}
          suppressDetails={this.state.advanceFilterConfig.suppressDetails}
        />
        <TableBody>{rows}</TableBody>
      </Table>
    );
  };

  virtualOpen = () => {
    this.setState({
      showVirtual: true
    });
  }

  // Event to check validations and export report in pdf or excel format.
  handleExport = (fileMimeType, type, isPrint) => {
    const { showSingleTotal } = this.state;
    const { fromDate, toDate } = this.getPayCyclesFromState();
    const count = getNumberOfPayCycle(fromDate, toDate);
    if (this.state.isUnlimitedPayCyclesEnabled !== true && count > this.state.noOfAllowedPayPeriodsForReports) {
      const message = 'You can select maximum '+ this.state.noOfAllowedPayPeriodsForReports +' paycycles';
      ShowToast(
        message,
        toastType.WARNING,
        5000,
        500
      );
    } else {
      if (type.toLowerCase() === 'PDF'.toLowerCase()) {        
        if (showSingleTotal === false && count > 3) {
          let message = 'PDF is not a suitable option to show these many pay cycles. This will lead to distorted UI in the PDF. Either go for the excel option in order to view the data. Still, do you want to continue?';
          if (isPrint) {
            message = 'PDF is not a suitable option to show these many pay cycles. This will lead to distorted UI in the PDF. Either go for the excel option in order to view the data. Still, do you want to continue?';
          }
          this.setState({
            openDialog: true,
            dialogTitle: null,
            fileMimeType,
            type,
            isPrint,
            confirmationMessage: message
          });
        } else {
          this.downloadFile(fileMimeType, type, isPrint);
        }
      } else {
        this.downloadFile(fileMimeType, type, isPrint);
      }
    }
  }

  // Download SSRS report in selected formats like pdf or excel
  downloadFile = (fileMimeType, type, isPrint) => {
    const { market, property, department, employee, payPeriodStartDate, payPeriodEndDate, advanceFilterConfig, expenseGroup, expenseName, division, SupervisorEmployee, showSingleTotal } = this.state;
    const dataValue = [
      { key: 'StartDate', value: moment(payPeriodStartDate).format(DateFormat) },
      { key: 'EndDate', value: moment(payPeriodEndDate).format(DateFormat) }
    ];
    const marketId = _.cloneDeep(market.map((x) => x.marketId));
    const departmentId = _.cloneDeep(department.map((x) => x.departmentId));
    const employeeId = _.cloneDeep(employee.map((x) => x.employeeId));
    const expenseGroupId = _.cloneDeep(expenseGroup.map((x) => x.expenseGroupId));
    const expenseNameId = _.cloneDeep(expenseName.map((x) => x.expenseNameId));
    const divisionId = _.cloneDeep(division.map((x) => x.divisionId));
    const supervisorId = _.cloneDeep(SupervisorEmployee.map((x) => x.ultiProEmployeeId));

    dataValue.push({ key: 'MarketId', value: (marketId.join('|') === undefined || marketId.join('|') === '') ? '0' : marketId.join('|') });
    dataValue.push({ key: 'DepartmentId', value: (departmentId.join('|') === undefined || departmentId.join('|') === '') ? '0' : departmentId.join('|') });
    dataValue.push({ key: 'EmployeeId', value: (employeeId.join('|') === undefined || employeeId.join('|') === '') ? '0' : employeeId.join('|') });
    dataValue.push({ key: 'ExpenseGroupId', value: (expenseGroupId.join('|') === undefined || expenseGroupId.join('|') === '') ? '0' : expenseGroupId.join('|') });
    dataValue.push({ key: 'ExpenseNameId', value: (expenseNameId.join('|') === undefined || expenseNameId.join('|') === '') ? '0' : expenseNameId.join('|') });
    dataValue.push({ key: 'DivisionId', value: (divisionId.join('|') === undefined || divisionId.join('|') === '') ? '0' : divisionId.join('|') });
    dataValue.push({ key: 'ShowSensitiveData', value: IsSensitiveDataAccess() });
    dataValue.push({ key: 'SuppressZero', value: advanceFilterConfig.suppressZero === true ? 1 : 0 });
    if (supervisorId && supervisorId.length > 0) {
      dataValue.push({ key: 'supervisorId', value: supervisorId.join('|') === undefined ? '' : supervisorId.join('|') });
    }
    dataValue.push({ key: 'ShowTotalColumn', value: showSingleTotal || false });
    let url = '';
    if (advanceFilterConfig.suppressDetails === true) {
      url = GenerateAbsoluteURL(dataValue, advanceFilterConfig.groupBy.selected, 'Market%20Reimbursement%20Summary%20Report', type);
    } else {
      dataValue.push({ key: 'ShowSummaryRow', value: advanceFilterConfig.summaryRows === true ? 1 : 0 });
      url = GenerateAbsoluteURL(dataValue, advanceFilterConfig.groupBy.selected, 'Market%20Reimbursement%20Report', type);
    }
    downloadReport(
      url,
      'Market Reimbursement Report',
      fileMimeType,
      type,
      isPrint
    );
  }

  // Check date validations and get report
  validateDate_Old(fromDate, toDate, marketId, propertyId, departmentId, employeeId, expenseGroupId, expenseNameId, divisionId, supervisorId, showSingleTotal) {
    if (fromDate === 'Invalid date' || toDate === 'Invalid date') {
      const message = 'Please select valid date';
      this.setState({
        openDialog: true,
        dialogTitle: null,
        confirmationMessage: message,
        AgreeText: '',
        DisAgreeText: 'Ok'
      });
    } else {
      const count = getNumberOfPayCycle(fromDate, toDate);      
      if (this.state.isUnlimitedPayCyclesEnabled !== true && count > this.state.noOfAllowedPayPeriodsForReports) {
        const message = 'You can select maximum '+ this.state.noOfAllowedPayPeriodsForReports +' paycycles';
        this.setState({
          openDialog: true,
          dialogTitle: null,
          confirmationMessage: message,
          AgreeText: '',
          DisAgreeText: 'Ok'
        });
      } else {
        const { user } = store.getState();
        const noOfAllowedPayPeriodsForReports = (user.userData || {}).noOfAllowedPayPeriodsForReports;

        if (count > noOfAllowedPayPeriodsForReports && marketId.join('|') === '') {
          const message = 'You have selected All Markets and more than ' + noOfAllowedPayPeriodsForReports?.toString() + ' Pay Periods. \nThe Data will be exported into Excel instead of displaying on the screen due to high volume. \nDo you want continue to export?';
          
          this.setState({
            openDialog: true,
            dialogTitle: 'Download to Excel',
            fileMimeType: 'application/vnd.ms-excel',
            type: 'Excel',
            isPrint: false,
            confirmationMessage: message
          });
        } else {
          const params = {
            fromDate: moment(fromDate).format(DateFormat),
            toDate: moment(toDate).format(DateFormat),
            marketId: marketId.join('|'),
            propertyId: propertyId.join('|'),
            departmentId: departmentId.join('|'),
            employeeId: employeeId.join('|'),
            expenseGroupId: expenseGroupId.join('|'),
            expenseNameId: expenseNameId.join('|'),
            divisionId: divisionId.join('|'),
            supervisorId: supervisorId.join('|'),
            showSingleTotal: showSingleTotal
          };

          this._asyncRequest = apiBatchRequest([
            {
              url: API_URL.Report.GetMarketReimburseData,
              params,
              key: 'marketReimburseData'
            }
          ]).then(({ marketReimburseData }) => {
            this._asyncRequest = null;
            if (marketReimburseData.success !== true) {
              ShowToast(
                commonLabels.somethingWrong,
                toastType.ERROR,
                5000,
                500,
                'Server error'
              );
            }
            const marketReimburseDataValue = marketReimburseData.data || [];
            const payPeriod = marketReimburseDataValue.length > 0
              ? _.chain(marketReimburseDataValue[0].reimbursmentDetails).groupBy('payPeriod')
                .map(function (_des, desi) {
                  return {
                    payPeriod: desi,
                    isCollapsed: true
                  };
                })
                .value()
              : [];
            defaultPayPeriod = payPeriod;
            const rows = this.getTableRow(marketReimburseDataValue);
            this.setState({
              marketReimburseData: marketReimburseDataValue,
              rows,
              payPeriod,
              showReport: true,
              isSubmitButtonClicked: true,
              expand: false,
              downloadMessage: null
            });
          });
        }
      } 
    }
  }

  // Check date validations and get report
  validateDate(fromDate, toDate, marketId, propertyId, departmentId, employeeId, expenseGroupId, expenseNameId, divisionId, supervisorId, showSingleTotal) {
    if (fromDate === 'Invalid date' || toDate === 'Invalid date') {
      const message = 'Please select valid date';
      this.setState({
        openDialog: true,
        dialogTitle: null,
        confirmationMessage: message,
        AgreeText: '',
        DisAgreeText: 'Ok'
      });
    } else {
      const count = getNumberOfPayCycle(fromDate, toDate);      
      if (this.state.isUnlimitedPayCyclesEnabled !== true && count > this.state.noOfAllowedPayPeriodsForReports) {
        const message = 'You can select maximum '+ this.state.noOfAllowedPayPeriodsForReports +' paycycles';
        this.setState({
          openDialog: true,
          dialogTitle: null,
          confirmationMessage: message,
          AgreeText: '',
          DisAgreeText: 'Ok'
        });
      } else {
        if (count > this.state.noOfAllowedPayPeriodsForReportsUI && marketId.join('|') === '') {          
          const message = 'You have selected All Markets and more than ' + this.state.noOfAllowedPayPeriodsForReportsUI?.toString() + ' Pay Periods. \nThe Data will be exported into Excel instead of displaying on the screen due to high volume. \nDo you want continue to export?';
          
          this.setState({
            openDialog: true,
            dialogTitle: 'Download to Excel',
            fileMimeType: 'application/vnd.ms-excel',
            type: 'Excel',
            isPrint: false,
            confirmationMessage: message
          });
        } else {
          let dataUrl = [];
          let reqCount = 0;
          const { noOfMarketsInSingleRequestForReimbursement, marketMasterData } = this.state;

          if(noOfMarketsInSingleRequestForReimbursement > 0) {
            if(marketId.join('|') === '') {
              marketId = marketMasterData.filter(x => x.marketId).map(x=> x.marketId);
            }
          }

          const params = {
            fromDate: moment(fromDate).format(DateFormat),
            toDate: moment(toDate).format(DateFormat),
            // marketId: marketId.join('|'),
            propertyId: propertyId.join('|'),
            departmentId: departmentId.join('|'),
            employeeId: employeeId.join('|'),
            expenseGroupId: expenseGroupId.join('|'),
            expenseNameId: expenseNameId.join('|'),
            divisionId: divisionId.join('|'),
            supervisorId: supervisorId.join('|'),
            showSingleTotal: showSingleTotal
          };

          if(noOfMarketsInSingleRequestForReimbursement > 0) {
            reqCount = Math.ceil(marketId.length / noOfMarketsInSingleRequestForReimbursement);
            for (let i = 0; i < reqCount; i++) {
              params.marketId = marketId.slice(i*noOfMarketsInSingleRequestForReimbursement, (i+1) * noOfMarketsInSingleRequestForReimbursement).join('|');  
              dataUrl.push({
                url: API_URL.Report.GetMarketReimburseData,
                params: cloneDeep(params),
                key: 'marketReimburseData'+ i
              })    
            }
          } else {
            reqCount = 1;
            params.marketId = marketId.join('|');  
            dataUrl.push({
              url: API_URL.Report.GetMarketReimburseData,
              params: cloneDeep(params),
              key: 'marketReimburseData0'
            })
          }

          this._asyncRequest = apiBatchRequest(dataUrl)
            .then((res) => {
            this._asyncRequest = null;
            let marketReimburseDataValue = [];
            for (let i = 0; i < reqCount; i++) {
              if (res['marketReimburseData'+ i].success !== true) {
                ShowToast(
                  commonLabels.somethingWrong,
                  toastType.ERROR,
                  5000,
                  500,
                  'Server error'
                );
              } else {
                marketReimburseDataValue = [...marketReimburseDataValue, ...res['marketReimburseData'+ i].data];
              }
            }

            const payPeriod = marketReimburseDataValue.length > 0
              ? _.chain(marketReimburseDataValue[0].reimbursmentDetails).groupBy('payPeriod')
                .map(function (_des, desi) {
                  return {
                    payPeriod: desi,
                    isCollapsed: true
                  };
                })
                .value()
              : [];
            defaultPayPeriod = payPeriod;
            const rows = this.getTableRow(marketReimburseDataValue);
            this.setState({
              marketReimburseData: marketReimburseDataValue,
              rows,
              payPeriod,
              showReport: true,
              isSubmitButtonClicked: true,
              expand: false,
              downloadMessage: null
            });
          });
        }
      } 
    }
  }

  // Get max To-date based on From-date selection and set it to To-date calendar.
  // It is applicable when pay period selection is restricted.
  getMaxDate(formattedDate) {
    const count = getNumberOfPayCycle(formattedDate, moment().format(DateFormat));
    let futureEndDate;
    if (count > 6) {
      futureEndDate = moment(formattedDate).add(3, 'M').format('MM/DD/YYYY');
    } else {
      futureEndDate = moment().endOf('month').format('MM/DD/YYYY');
    }
    return futureEndDate;
  }

  // Click event of switch button "Show Single Total". 
  // It will set true/false value to the variable showSingleTotal
  // If the value is true, it will show totals of all selected pay periods
  // If the value is false, it will show pay period wise
  ShowSingleTotal = (checked) => {    
    this.setState({ showSingleTotal: checked });
  }

  // Method to render the components based on conditions
  render() {
    const {
      showMain,
      employeeMasterData,
      departmentMasterData,
      marketMasterData,
      marketReimburseData,
      rows,
      expenseGroupMasterData,
      expenseNameMasterData,
      payPeriodStartDate,
      payPeriodEndDate,
      showReport,
      openSlidingPanel,
      advanceFilterConfig,
      expand,
      handleCollapse,
      futureEndDate,
      maxEndDate,
      divisionMasterData,
      supervisorEmployeeMasterData,
      showSingleTotal
    } = this.state;

    if (marketMasterData.find(x => x.marketName === 'All') === undefined) {
      marketMasterData.unshift({ marketName: 'All' });
    }
    if (employeeMasterData.find(x => x.employeeName === 'All') === undefined) {
      employeeMasterData.unshift({ employeeName: 'All' });
    }
    if (departmentMasterData.find(x => x.departmentName === 'All') === undefined) {
      departmentMasterData.unshift({ departmentName: 'All' });
    }
    if (expenseGroupMasterData.find(x => x.expenseGroup === 'All') === undefined) {
      expenseGroupMasterData.unshift({ expenseGroup: 'All' });
    }
    if (expenseNameMasterData.find(x => x.expenseName === 'All') === undefined) {
      expenseNameMasterData.unshift({ expenseName: 'All' });
    }
    if (divisionMasterData.find(x => x.division === 'All') === undefined) {
      divisionMasterData.unshift({ division: 'All' });
    }

    if (supervisorEmployeeMasterData.find(x => x.employeeName === 'All') === undefined) {
      supervisorEmployeeMasterData.unshift({ employeeName: 'All' });
    }

    return (
      <>
        {showMain
          ? (
            <Reports />
          )
          : (
            <>
              <PageHeader
                key={'Market_Reimbursement_Report'}
                title={'Market Reimbursement Report'}
                actionsConfig={[
                  {
                    icon: (
                      <ArrowBackIcon
                        size="small"
                        className="back-button no-print"
                      />
                    ),
                    onClick: this.goBack,
                    title: 'Back to Report'
                  }
                ]}
              >
                Market Reimbursement Report
              </PageHeader>
              <Grid container spacing={3} className="no-print row top-xs" style={{ marginLeft: '10px' }}>
                <Grid item xs={12} lg={2}>
                  <Grid item xs={12} >
                    <Autocomplete
                      multiple
                      blurOnSelect
                      limitTags={1}
                      value={this.state.market}
                      onChange={(e, val) => this.handleChange(e, val, 'market', 'marketName')}
                      id="tags-standard"
                      options={removeDuplicates(marketMasterData, 'marketName')}
                      getOptionLabel={(option) => option.marketName}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Market"
                        // placeholder="Market"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                      blurOnSelect
                      multiple
                      limitTags={1}
                      id="tags-standard"
                      value={this.state.expenseGroup}
                      options={removeDuplicates(expenseGroupMasterData, 'expenseGroup')}
                      onChange={(e, val) => this.handleChange(e, val, 'expenseGroup', 'expenseGroup')}
                      getOptionLabel={(option) => option.expenseGroup}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Expense Group"
                        // placeholder="Expense Group"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} lg={2}>
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      limitTags={1}
                      blurOnSelect
                      id="tags-standard"
                      options={removeDuplicates(departmentMasterData, 'departmentName')}
                      getOptionLabel={(option) => option.departmentName}
                      value={this.state.department}
                      onChange={(e, val) =>
                        this.handleChange(e, val, 'department', 'departmentName')
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Department"
                        // placeholder="Department"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                      blurOnSelect
                      multiple
                      limitTags={1}
                      id="tags-standard"
                      value={this.state.expenseName}
                      options={removeDuplicates(expenseNameMasterData, 'expenseName')}
                      onChange={(e, val) => this.handleChange(e, val, 'expenseName', 'expenseName')}
                      getOptionLabel={(option) => option.expenseName}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Expense Name"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} lg={2}>
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      limitTags={1}
                      blurOnSelect
                      id="tags-standard"
                      options={removeDuplicates(employeeMasterData, 'employeeName')}
                      getOptionLabel={(option) => option.employeeName}
                      value={this.state.employee}
                      onChange={(e, val) => this.handleChange(e, val, 'employee', 'employeeName')}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Employee"
                        // placeholder="Employee Name"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                      blurOnSelect
                      multiple
                      limitTags={1}
                      id="tags-standard"
                      value={this.state.division}
                      options={removeDuplicates(divisionMasterData, 'division')}
                      onChange={(e, val) => this.handleChange(e, val, 'division', 'division')}
                      getOptionLabel={(option) => option.division}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Division"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} lg={2}>
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      limitTags={1}
                      blurOnSelect
                      id="tags-standard"
                      value={this.state.SupervisorEmployee || ''}
                      options={removeDuplicates(supervisorEmployeeMasterData, 'employeeName')}
                      getOptionLabel={(option) => option.employeeName}
                      onChange={(e, val) => {
                        this.handleChange(e, val, 'SupervisorEmployee', 'employeeName');
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Supervisor Name"
                        // placeholder="Employee Name"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Grid style={{ marginTop: '10px' }}>
                      <Switch
                        isChecked={showSingleTotal}
                        onChangeValues={(checked, key) => {
                          this.ShowSingleTotal(checked);
                        }}
                        id={'switch_show_single_total_id'}
                        labelText={'Show Single Total'}
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} lg={2}>
                  <Grid item xs={12} style={{ marginTop: '8px' }}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <Grid container justify="space-around">
                        <KeyboardDatePicker
                          margin="normal"
                          id="date-picker-dialog"
                          label="Pay Period(From)"
                          // minDate={this.state.pastStartDate}
                          format="MM/dd/yyyy"
                          // maxDate={maxEndDate}// {payPeriodEndDate}
                          value={payPeriodStartDate}
                          name={'payPeriodStartDate'}
                          onChange={(e) =>
                            this.handleDateChange(e, 'payPeriodStartDate')
                          }
                          KeyboardButtonProps={{
                            'aria-label': 'change date'
                          }}
                          shouldDisableDate={this.disableDatesForPayCycleStart}
                          maxDateMessage= {'Please select date within '+this.state.noOfAllowedPayPeriodsForReports+' Pay Periods'}
                          minDateMessage= {'Please select date within '+this.state.noOfAllowedPayPeriodsForReports+' Pay Periods'}
                        />
                      </Grid>
                    </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid item xs={12} style={{ marginTop: '8px' }}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <Grid container justify="space-around">
                        <KeyboardDatePicker
                          margin="normal"
                          id="date-picker-dialog"
                          label="Pay Period(To)"
                          format="MM/dd/yyyy"
                          value={payPeriodEndDate}
                          minDate={payPeriodStartDate}
                          name={'payPeriodEndDate'}
                          maxDate= {futureEndDate}
                          onChange={(e) =>
                            this.handleDateChange(e, 'payPeriodEndDate')
                          }
                          KeyboardButtonProps={{
                            'aria-label': 'change date'
                          }}
                          shouldDisableDate={this.disableDatesForPayCycleEnd}
                          maxDateMessage='Please select date within two Pay Periods'
                          minDateMessage='Please select date within two Pay Periods'
                        />
                      </Grid>
                    </MuiPickersUtilsProvider>
                  </Grid>                  
                </Grid>
                <ReportButtons
                  resetPage={this.resetPage}
                  handleSubmit= {this.handleSubmit}
                  handleClickOpen={this.handleClickOpen}
                  handlePrintClick={this.handlePrintClick}
                  data={marketReimburseData}
                  downloadFile={this.handleExport}
                  virtualOpen={this.virtualOpen}
                />
              </Grid>

              <div className="col-lg-3 buttons">
                <div className="col-lg-12">
                  <AdvancedFilter
                    payPeriodStartDate={this.state.payPeriodStartDate}
                    payPeriodEndDate={this.state.payPeriodEndDate}
                    filterConfig={advanceFilterConfig}
                    onApplyFilter={this.onAddvanceFilterChange}
                    openSlidingPanel={openSlidingPanel}
                    handleClose={this.handleClose}
                  />
                </div>
              </div>
              {/* If Auto Run is not enabled and buttons not clicked, then show message to click button */}
              {(this.state.isAutoRunEnabled === false && this.state.isSubmitButtonClicked === false) && 
                (marketReimburseData === null || marketReimburseData.length <= 0) && (
                  <PageLandingMessage/>
                )
              }
              {/* If no data is found then show the message */}
              {showReport &&
                (marketReimburseData === null ||
                  marketReimburseData.length <= 0) && (
                  <Grid container spacing={4}>
                    <Grid
                      container
                      direction="row-reverse"
                      justify="center"
                      alignItems="stretch"
                    >
                      <label className="item-big"> { this.state.downloadMessage !== null ? this.state.downloadMessage : 'No Data Available.' } </label>
                    </Grid>
                  </Grid>
                )}

              <ConfirmDialog
                IsOpen={this.state.openDialog}
                Title={this.state.dialogTitle}
                Message={this.state.confirmationMessage}
                OnHandelClick={(isValid) => {
                  if (isValid) {
                    this.onConfirmClickHandle(isValid);
                  } else {
                    this.onConfirmClickHandle(isValid);
                  }
                }}
                AgreeText={this.state.AgreeText === '' ? '' : 'Yes'}
                DisAgreeText={this.state.DisAgreeText || 'No'}
              />
              {/* If data is found then display the data */}
              {showReport &&
                marketReimburseData !== null &&
                marketReimburseData.length > 0 && (
                  <TableWithPaginations
                    tableData={rows}
                    renderTable={this.renderTable}
                    expand={expand}
                    handleCollapse={handleCollapse}
                    order={this.state.order}
                    oBy={this.state.orderBy}
                  />
                )}
            </>
          )}
      </>
    );
  }
}
